import { disableUnder10YearsAgo, useFocusOnLoad } from "@Utils";
import { DatePicker, Form, Input, InputRef } from "antd";
import React, { useContext } from "react";
import { MainContext } from "@Context/provider";
import CountrySelect from "./CountrySelect";
import GenderSelect from "./GenderSelect";
import { ViewMode } from "@Context/state";

interface RegistrationDetailsProps {
    current: number;
}

const RegistrationDetails = ({ current }: RegistrationDetailsProps) => {
    const isCurrent = current === 0;
    const inputToFocusRef = useFocusOnLoad<InputRef>(isCurrent);
    const dateFormatList: string[] = ["DD/MM/YYYY", "DD/MM/YY"];
    const { ui: uiState } = useContext(MainContext);
    const isDesktop = uiState.mode === ViewMode.desktop;

    return (
        <div className="your-details-form" style={isCurrent ? null : { display: "none " }}>
            <Form.Item
                label="Full name"
                name="fullName"
                className={isDesktop ? "black-label" : ""}
                rules={[
                    {
                        required: true,
                        message: "Please tell us your full name",
                    },
                ]}
            >
                <Input placeholder="Please tell us your full name" ref={inputToFocusRef} />
            </Form.Item>
            <Form.Item
                label="What shall we call you?"
                name="nickName"
                className={isDesktop ? "black-label" : ""}
                rules={[
                    {
                        required: true,
                        message: "Maybe just your first name or a nickname",
                    },
                ]}
            >
                <Input placeholder="Please tell us your nickname" />
            </Form.Item>
            <Form.Item
                label="Date of Birth"
                name="dateOfBirth"
                className={isDesktop ? "black-label" : ""}
                rules={[
                    {
                        required: true,
                        message: "Please tell us your date of birth",
                    },
                ]}
            >
                <DatePicker allowClear={false} format={dateFormatList} disabledDate={disableUnder10YearsAgo} />
            </Form.Item>
            <Form.Item
                label="Country"
                name="countryCode"
                className={isDesktop ? "black-label" : ""}
                rules={[
                    {
                        required: true,
                        message: "Please select your country",
                    },
                ]}
            >
                <CountrySelect />
            </Form.Item>
            <Form.Item
                label="Gender"
                name="gender"
                className={isDesktop ? "black-label" : ""}
                rules={[
                    {
                        required: true,
                        message: "Please select your gender",
                    },
                ]}
            >
                <GenderSelect />
            </Form.Item>
        </div>
    );
};

export default RegistrationDetails;
